export const ADD_FIELD = "internal_add";
export const PRE_DEFINED_FIELD = "internal_pre_defined";
export const PRE_DEFINED_CREATE_FIELD = "internal_pre_defined_create";
export const PRE_DEFINED_UPDATE_FIELD = "internal_pre_defined_update";
export const TECHNOGRAPHICS_FIELD = "internal_technographics";
